// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4078":"c481ccaa","7635":"5af4954b","8243":"5af4954b"}[chunkId] + ".chunk.css";
};